import { useFormik } from 'formik';
import * as Yup from 'yup';

const hasAnyDateTimeField = (parent) =>
  Boolean(parent.meetingDate || parent.startTime || parent.endTime);

const Schema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  meetingDate: Yup.string()
    .nullable()
    .when(['startTime', 'endTime'], {
      is: (startTime, endTime) => Boolean(startTime || endTime),
      then: (schema) => schema.required('Date is required')
    }),
  startTime: Yup.string()
    .nullable()
    .test('required-with-group', 'Start time is required', function (value) {
      return !hasAnyDateTimeField(this.parent) || Boolean(value);
    }),
  endTime: Yup.string()
    .nullable()
    .test('required-with-group', 'End time is required', function (value) {
      return !hasAnyDateTimeField(this.parent) || Boolean(value);
    })
    .test('is-after-start', 'End time must be after start time', function (value) {
      const start = this.parent.startTime;
      if (!value || !start) return true;
      return value.localeCompare(start) > 0;
    }),
  meetingLink: Yup.string().url('Enter a valid URL').nullable()
});

export default function useEditTrainingFormik(initialValues = {}, onSubmit = () => {}) {
  const formik = useFormik({
    initialValues: {
      name: initialValues?.name ?? '',
      meetingDate: initialValues?.meetingDate ?? '',
      startTime: initialValues?.startTime ?? '',
      endTime: initialValues?.endTime ?? '',
      meetingLink: initialValues?.meetingLink ?? ''
    },
    enableReinitialize: true,
    validationSchema: Schema,
    onSubmit
  });

  return formik;
}
